export const UNSUBMITTED = 'UNSUBMITTED'
export const NONSUBMIT = 'NONSUBMIT'
export const PENDING = 'PENDING'
export const APPROVED = 'APPROVED'
export const REJECTED = 'REJECTED'
export const CANCEL = 'CANCEL'
export const POSTPONE = 'POSTPONE'
export const HOLIDAY = 'HOLIDAY'
export const COMPENSATE = 'COMPENSATE'
export const LEAVE = 'LEAVE'
export const WEEKEND = 'WEEKEND'
export const FULLDAY = 'FULLDAY'

export const FIXFEE = 'FIXFEE'
export const TIME_MATERIAL = 'TIME_MATERIAL'
export const SUPPORT = 'SUPPORT'
export const COMMON = 'COMMON'
export const SPECIFIC = 'SPECIFIC'



// WEBPACK FOOTER //
// ./src/components/timesheet/constants.js